import CloudStorage from './CloudStorage';
export default CloudStorage;
